if (!customElements.get('padilla-purchase-bar')) {
  customElements.define('padilla-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-padilla-product]');
      this.form = this.root?.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.mainButton = this.form?.querySelector('button[name="add"]');
      this.button = this.querySelector('[data-padilla-add]');
      this.price = this.querySelector('[data-padilla-price]');
      this.priceRoot = this.root?.querySelector('[id^="price-"]');
      if (!this.mainButton || !this.button || !this.priceRoot) return;
      this.variants = JSON.parse(this.querySelector('[data-padilla-variants]').textContent);
      this.error = this.querySelector('[data-padilla-error]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onUpdate = () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onClick = () => {
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        this.mainButton.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.onUpdate);
      window.addEventListener('scroll', this.onUpdate, { passive: true });
      window.visualViewport?.addEventListener('resize', this.onUpdate);
      this.form.addEventListener('change', this.onUpdate);
      this.observer = new IntersectionObserver(this.onUpdate, { threshold: [0, 0.5, 1] });
      this.observer.observe(this.mainButton);
      this.mutation = new MutationObserver(this.onUpdate);
      this.mutation.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
      this.mutation.observe(this.priceRoot, { childList: true, subtree: true });
      this.update();
    }
    update() {
      const canonicalPrice = [...this.priceRoot.querySelectorAll('.price-item--sale, .price-item--regular')]
        .find(node => node.getBoundingClientRect().width > 0);
      const selected = this.variants.find(variant => String(variant.id) === this.form.elements.namedItem('id')?.value);
      const priceText = selected?.price || canonicalPrice?.textContent.trim();
      if (priceText && this.price.textContent !== priceText) this.price.textContent = priceText;
      const loading = this.mainButton.getAttribute('aria-disabled') === 'true' ||
        this.mainButton.classList.contains('loading');
      this.button.disabled = this.mainButton.disabled || loading;
      this.button.setAttribute('aria-busy', String(loading));
      const label = loading ? 'Adding…' : (this.mainButton.disabled ? 'Sold out' : 'Add to Cart');
      if (this.button.textContent !== label) this.button.textContent = label;
      this.button.setAttribute('aria-label', `${label}: ${this.root.querySelector('.product__title h1')?.textContent.trim() || 'cigars'}`);
      const nativeError = this.form.closest('product-form').querySelector('.product-form__error-message-wrapper');
      const errorText = nativeError && !nativeError.hidden ? nativeError.textContent.trim() : '';
      this.error.hidden = !errorText;
      if (this.error.textContent !== errorText) this.error.textContent = errorText;
      const rect = this.mainButton.getBoundingClientRect();
      const viewportHeight = Math.min(document.documentElement.clientHeight, window.visualViewport?.height || Infinity);
      const mainVisible = rect.height > 0 && rect.top >= 0 && rect.bottom <= viewportHeight;
      const visible = this.mobile.matches && !mainVisible;
      this.hidden = !visible;
      document.documentElement.classList.toggle('padilla-purchase-bar-visible', visible);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.mobile?.removeEventListener('change', this.onUpdate);
      window.removeEventListener('scroll', this.onUpdate);
      window.visualViewport?.removeEventListener('resize', this.onUpdate);
      this.form?.removeEventListener('change', this.onUpdate);
      this.observer?.disconnect();
      this.mutation?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.documentElement.classList.remove('padilla-purchase-bar-visible');
    }
  });
}
